import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const BlogRecentSidebar = ({
  posts,
  activeSlug,
  showSidebar,
  onToggle,
  title = "Related Posts",
}) => {
  const activeRef = useRef(null);

  useEffect(() => {
    if (showSidebar && activeSlug && activeRef.current) {
      activeRef.current.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [showSidebar, activeSlug, posts.length]);

  return (
    <aside className="blog-sidebar-panel">
      <div className="blog-sidebar-header">
        <h2 className="blog-sidebar-title">{title}</h2>
        <button
          type="button"
          className="blog-sidebar-toggle"
          onClick={onToggle}
          aria-expanded={showSidebar}
        >
          Hide list
        </button>
      </div>

      <div className="blog-sidebar-scroll">
        {posts.map((post) => {
          const isActive = activeSlug === post.slug;
          return (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              ref={isActive ? activeRef : null}
              className={`blog-sidebar-item${isActive ? " active" : ""}`}
              aria-current={isActive ? "page" : undefined}
            >
              <span className="blog-sidebar-post-title">{post.title}</span>
            </Link>
          );
        })}
      </div>
    </aside>
  );
};

export default BlogRecentSidebar;
